/**
 * Enable/disable keyboard focusability on a given element
 * 
 * The function iterates over the element itself and all of its focusable child elements:
 * 
 * if focusable: It saves the current tabindex to the elements data-tabindex-original attribute and sets it to -1
 * if not focusable: It removes the tabindex attribute and restores the original tabindex
 * 
 * @param {*} $element 
 */

const $ = window.jQuery // Use global WP jQuery instance

const toggleKeyboardFocusability = element => {

    $('a, button, textarea, input, select', element).each(function () {

        const $childElement = $(this);
        const currentTabIndex = $childElement.attr('tabindex') || "novalue";
        const lastTabIndex = $childElement.attr('data-tabindex-original') || "novalue";
        const isToggled = $childElement.attr('data-tabindex-original') !== undefined;

        if (isToggled) {
            if (lastTabIndex !== "novalue") {
                $childElement.attr('tabindex', lastTabIndex);
            } else {
                $childElement.removeAttr('tabindex');
            }
            $childElement.removeAttr('data-tabindex-original');
        } else {
            $childElement.attr('data-tabindex-original', currentTabIndex);
            $childElement.attr('tabindex', -1);
        }
    })

}

export { toggleKeyboardFocusability };